/**
 * 挑选弹窗：运营从 Excel 粘贴多行资源名 → 拆行后走服务端批量精确查询。
 * 单行仍走原模糊搜；多行（≥2）触发 POST listByExactNames。
 * 一次最多接受 BATCH_PASTE_NAME_LIMIT 个名字（去重后截断）。
 */

/** 多行粘贴上限：抽屉展示与精确查询共用 */
export const BATCH_PASTE_NAME_LIMIT = 30

/**
 * 按换行拆名；去 BOM/空白/空行；大小写不敏感保序去重。
 * @returns {{ names: string[], truncated: boolean, totalUnique: number }}
 */
export function parsePastedResourceNames(text, limit = BATCH_PASTE_NAME_LIMIT) {
  const seen = new Set()
  const names = []
  let totalUnique = 0
  String(text || '')
    .split(/\r?\n/)
    .forEach((line) => {
      const name = String(line || '')
        .replace(/^\uFEFF/, '')
        .trim()
      if (!name) {
        return
      }
      const dedupeKey = name.toLowerCase()
      if (seen.has(dedupeKey)) {
        return
      }
      seen.add(dedupeKey)
      totalUnique += 1
      if (names.length < limit) {
        names.push(name)
      }
    })
  return {
    names,
    truncated: totalUnique > limit,
    totalUnique,
  }
}

/** 是否应按「多行批量精确匹配」路径查询（≥2 个有效名）。 */
export function isBatchNameQuery(text) {
  return parsePastedResourceNames(text).names.length >= 2
}
